import { getAuth } from 'firebase/auth';

export async function apiFetch(url, options = {}) {
  const auth = getAuth();
  const user = auth.currentUser;
  const token = user ? await user.getIdToken() : null;

  const headers = {
    ...(options.headers ?? {}),
    ...(token ? { 'X-Firebase-Token': token } : {}),
  };

  return fetch(url, { ...options, headers });
}
